'use strict';

const Mn = require('backbone.marionette');
const ReleaseNoteEntity = require('feedback/domain/entity/release-note');
const IdeaRelatedListView = require('feedback/ui/view/idea/related-list');
const Template = require('feedback/ui/template/announcement/detail.hbs');
const CoverView = require('feedback/ui/view/cover');
const Marked = require('balus/util/marked');

const DetailView = Mn.View.extend({
    tagName: 'div',
    className: 'announcement-detail',
    template: Template,
    regions: {
        cover: '#cover',
        announcementDetail: '.announcement-detail',
        ideaRelatedList: '.idea-related-list'
    },

    templateContext: function() {
        return {
            title: this.model.getTitle(),
            description: Marked()(this.model.getDescription()),
            publishedAt: this.model.getPublishedAt(),
            isReleaseNote: this.isReleaseNote()
        }
    },

    onRender: function() {
        this.showChildView('cover', new CoverView({isAnnouncement: true}));

        if(this.isReleaseNote()) {
            this.showChildView('ideaRelatedList', new IdeaRelatedListView({
                ideaKeys: this.model.getIdeaKeys()
            }));
        }
    },

    isReleaseNote: function() {
        return this.model instanceof ReleaseNoteEntity;
    }
});

module.exports = DetailView;



// WEBPACK FOOTER //
// ./feedback/ui/view/announcement/detail.js